import React, { useState } from 'react';
import { FormikValues } from 'formik';
import RadioButton from '@components/RadioButton';
import { BlackoutComponents } from '@pages/Schedule/components/Blackout/BlackoutForm/BlackoutComponents';
import { BlackoutType } from '@pages/Schedule/components/Blackout/type';

import './styles.scss';

interface IAddBlackoutProps {
  onSubmitFormForce: (formValues: FormikValues, closeModal: () => void) => void;
}

export const AddBlackout: React.FC<IAddBlackoutProps> = ({ onSubmitFormForce }) => {
  const [selectedValue, setSelectedValue] = useState<BlackoutType>(BlackoutType.physician);

  const handleRadioChange = (value: string) => {
    if (value === BlackoutType.physician || value === BlackoutType.location) {
      setSelectedValue(value as BlackoutType);
    }
  };

  return (
    <div className="form-body">
      <div className="row">
        <div className="col-xs-12">
          <div className="radio-button-container">
            <RadioButton
              name={BlackoutType.physician}
              label="Physician's"
              value={BlackoutType.physician}
              checked={selectedValue === BlackoutType.physician}
              onChange={handleRadioChange}
            />
          </div>
          <div>
            <RadioButton
              label="Location"
              name={BlackoutType.location}
              value={BlackoutType.location}
              checked={selectedValue === BlackoutType.location}
              onChange={handleRadioChange}
            />
          </div>
        </div>
      </div>
      <BlackoutComponents blackoutType={selectedValue} onSubmitFormForce={onSubmitFormForce} />
    </div>
  );
};
